import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { Dialog } from "primereact/dialog";
import { InputNumber } from "primereact/inputnumber";
import { useEffect, useState } from "react";
import '../Bitacoras.scss'
import { formatearFechaHora, horaStringAHoraDate, isoAFechaLocal } from "../../../../utilidades/formateos";
import { updateBitacora } from "../integracion";
import Swal from "sweetalert2";
export default function EditarModal({ visible, setVisible, data,getBitacorasFunc }) {


    const [form, setForm] = useState({
    });
    useEffect(() => {
        if (data) {
            setForm({
                fecha: isoAFechaLocal(data.FECHA),
                folio: data.FOLIO_SERVICIO,
                horaArranque: horaStringAHoraDate(data.HORA_ARRANQUE),
                horaLlegada: horaStringAHoraDate(data.HORA_LLEGADA),
                unidad: data.ID_UNIDAD,
                kmInicial: data.KM_INICIAL,
                kmFinal: data.KM_FINAL
            })
        }
    }, [data])

    const actualizarBitacora = async()=>
    {
         const formData = {
            id_bitacora: data.BITACORA,
            folio: form.folio,
            hora_arranque: formatearFechaHora(form.horaArranque),
            hora_llegada: formatearFechaHora(form.horaLlegada),
            unidad:form.unidad,
            km_inicial: form.kmInicial,
            km_final: form.kmFinal

        }
        if( 
            formData.id_bitacora&&
            formData.folio&&
            formData.hora_arranque&&
            formData.hora_llegada&&
            formData.unidad&&
            formData.km_inicial&&
            formData.km_final
        )
        {
            await updateBitacora(formData, setVisible)
            await getBitacorasFunc()
        }
        else{
            Swal.fire({
                icon:'error',
                text:'Todos los campos son obligatorios, favor de llenarlos'
            })
        }
    }
    const onInputChange = (key, value) => {
        setForm((prev) => ({ ...prev, [key]: value }));
    };

    return (

        <Dialog
            header={`EDITAR BITÁCORA ${data?.BITACORA}`}
            visible={visible}
            style={{ width: '40rem' }}
            onHide={() => { setVisible(false) }}
            className="bitacora-modal-container"
            modal
        >
            {/* Formulario en grid */}
            <div className="bitacoras-grid">
                <div>
                    <label>Fecha</label>
                    <Calendar
                        value={form.fecha}
                        onChange={(e) => onInputChange("fecha", e.value)}
                        dateFormat="dd/mm/yy"
                        showIcon
                        className="w-full"
                        disabled
                    />
                </div>

                <div>
                    <label>Folio</label>
                    <InputNumber
                        value={form.folio}
                        onValueChange={(e) => onInputChange("folio", e.value)}
                        inputClassName="w-full"
                        useGrouping={false}
                    />
                </div>

                <div>
                    <label>Hora Arranque</label>
                    <Calendar
                        value={form.horaArranque}
                        onChange={(e) => onInputChange("horaArranque", e.value)}
                        timeOnly
                        hourFormat="24"
                        className="w-full"
                    />
                </div>

                <div>
                    <label>Hora Llegada</label>
                    <Calendar
                        value={form.horaLlegada}
                        onChange={(e) => onInputChange("horaLlegada", e.value)}
                        timeOnly
                        hourFormat="24"
                        className="w-full"
                    />
                </div>

                <div>
                    <label>Unidad</label>
                    <InputNumber
                        value={form.unidad}
                        onValueChange={(e) => onInputChange("unidad", e.value)}
                        inputClassName="w-full"
                        useGrouping={false}
                    />
                </div>

                <div>
                    <label>Kilometraje Inicial</label>
                    <InputNumber
                        value={form.kmInicial}
                        onValueChange={(e) => onInputChange("kmInicial", e.value)}
                        inputClassName="w-full"
                        useGrouping={false}
                    />
                </div>

                <div>
                    <label>Kilometraje Final</label>
                    <InputNumber
                        value={form.kmFinal}
                        onValueChange={(e) => onInputChange("kmFinal", e.value)}
                        inputClassName="w-full"
                        useGrouping={false}
                    />
                </div>
            </div>

            {/* Botones al pie del modal */}
            <div className="bitacora-dialog-footer">
                <Button label="Cancelar" icon="pi pi-times" severity="secondary" onClick={() => { setVisible(false) }} />
                <Button label="Guardar" icon="pi pi-check" onClick={() => actualizarBitacora()} autoFocus />
            </div>
        </Dialog>
    );
}